import isBrowser from './isBrowser';

const hostname = (): string => (isBrowser() ? window.location.hostname : 'fabfitfun.com');

export { hostname };
